// @ts-nocheck
import closeIcon from '../../../../assets/icons/adminScreen/closeIcon.svg';
import { useForm } from 'react-hook-form';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/CheckBox';
import SelectBox from '../../../../components/SelectBox';
import ModalPopup from '../../../../components/Modal';
import { usePermission } from '../../../../hooks/usePermission';
import { useAsync } from'react-use';
import { useEvent } from '../../../../hooks/useEvent';
import { notification } from 'antd';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

const EditAdminPermissionPopup = (props) => {
  const { setEditAdminPermissions, editAdminPermissions } = props;

  const { getAdmins } = props;
  const { getAllEvents } = useEvent();
  const { getMenuItems } = usePermission();
  const { value: menuItems } = useAsync(() => getMenuItems(), []);
  const { value: allEvents } = useAsync(() => getAllEvents(), []);
  const { updateAdminPermission } = usePermission();

  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      ...editAdminPermissions,
      isSuperAdmin: editAdminPermissions?.isSuperAdmin,
    },
  });

  useEffect(() => {
    if (editAdminPermissions) {
      // Set default values for events
      const defaultEvents = allEvents?.events?.filter((item) =>
        editAdminPermissions?.events?.includes(item?._id)
      ) || [];
      setValue('eventList', defaultEvents);

      // Set default values for menu items
      menuItems?.forEach((item) => {
        setValue(item.name, editAdminPermissions?.menus?.includes(item.name));
      });
    }
  }, [editAdminPermissions, allEvents, menuItems, setValue]);

  const isSuperAdminValue = watch('isSuperAdmin');
  useEffect(() => {
    if (isSuperAdminValue) {
      setValue('eventList', []);
      menuItems?.map((item) => {
        setValue(item.name, false);
      });
    }
  }, [isSuperAdminValue]);

  const selectedMenuItems = menuItems?.map((permission) => {
    if (watch(permission.name)) {
      return permission.name;
    }
    return null;
  }).filter((item) => item !== null);

  const onSubmit = async (data) => {
    try {
      await updateAdminPermission(
        {
          id: editAdminPermissions._id,
          isSuperAdmin: data.isSuperAdmin,
          events: data.isSuperAdmin ? [] : data.eventList,
          menus: data.isSuperAdmin ? [] : selectedMenuItems,
        });
      notification.success({ message: 'Successfully updated permission' });
      await getAdmins();
      setEditAdminPermissions(null);
    } catch (error) {
      notification.error({ message: error?.message || 'Failed to update permission' });
    }
  };

  return (
    <ModalPopup
      fullScreen
    >
      <div className="w-screen h-screen pt-8 pb-12 bg-purple-50 flex-col justify-start items-start gap-8 inline-flex">
        <div className="self-stretch px-12 justify-between items-center inline-flex">
          <div className="text-indigo-600 text-xl font-semibold font-['Manrope']">
            Edit Admin Permission
          </div>
          <div
            className="w-8 h-8 relative cursor-pointer"
            onClick={() => setEditAdminPermissions(false)}
          >
            <img src={closeIcon} alt="icon" />
          </div>
        </div>
        <div className="self-stretch px-12 justify-start items-start gap-[18px] inline-flex">
          <div
            className="w-[800px] self-stretch p-6 bg-white rounded-lg flex-col
              justify-center items-start gap-4 inline-flex"
          >
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" className="w-full">
              <div className="grid grid-cols-12 gap-2 w-full">
                <div className="col-span-12 py-2">
                  <Checkbox
                    name="isSuperAdmin"
                    label="Is Super Admin"
                    labelFirst
                    control={control}
                    errors={errors}
                    customlabelclass="text-zinc-700 !text-sm !font-normal font-['Manrope']"
                  />
                </div>
                {/* Permission management */}
                <div className="col-span-12 py-2">
                  <SelectBox
                    name="eventList"
                    placeholder="Select Event"
                    label="Events"
                    options={allEvents?.events || []}
                    control={control}
                    errors={errors}
                    customLabel="name"
                    customValue="name"
                    customHeight="40px"
                    isClearable
                    isDisabled={isSuperAdminValue}
                    isMulti
                    customlabelclass="text-zinc-700 !text-sm !font-normal font-['Manrope'] !pb-2"
                  />
                </div>
                <div className="col-span-12 text-zinc-700 text-md font-semibold font-['Manrope'] flex justify-start pb-2">
                  Menu Items
                  {(!isSuperAdminValue && selectedMenuItems?.length <= 0) && (
                    <span className="text-xs text-red-500 ml-2 self-center">
                      (Select at least one menu item or check "Is Super Admin")
                    </span>
                  )}
                </div>
                {menuItems?.map((permission, index) => (
                  <div key={index+1} className="col-span-12 py-1">
                    <Checkbox
                      name={permission.name}
                      label={permission.label}
                      labelFirst
                      control={control}
                      errors={errors}
                      readOnly={isSuperAdminValue}
                      customlabelclass="text-zinc-700 !text-sm !font-normal font-['Manrope']"
                    />
                  </div>
                ))}
                <div className="col-span-12 flex justify-start">
                  <Button
                    customClass=""
                    variant="primary"
                    type="submit"
                  >
                    <div className="text-white text-base font-bold font-['Manrope']">Update</div>
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ModalPopup>
  );
};
EditAdminPermissionPopup.propTypes = {
  setEditAdminPermissions: PropTypes.func.isRequired,
  editAdminPermissions: PropTypes.object.isRequired,
  getAdmins: PropTypes.func.isRequired,
};

export default EditAdminPermissionPopup;
